<div class="body-container">
    <div class="screen-loading" *ngIf="screenLoading"></div>
    <div class="top-content-container">
        <div class="ia-config-title-container">
            <div class="title">Intelligent Advisor Configuration</div>
            <div class="note">Note: Select a plant to be able to start a configuration.</div>
        </div>
        <div class="dropdowns-container">
          <span class="multiplant-dropdown-container">
            <div class="field-container" (clickOutside)="onClickedOutsidePlants()">
              <div class="field-input-container">
                <input (click)="selectPlants()" class="field-input-dropdown" placeholder="Select a plant" [value]="userHasAccess ? selectedPlantName : ''" [disabled]="!userHasAccess" appPreventInput>
                <img *ngIf="userHasAccess" (click)="userHasAccess ? selectPlants() : ''" class="dropdown-arrow expandIcon" src=""/>
                <img *ngIf="!userHasAccess" (click)="userHasAccess ? selectPlants() : ''" class="dropdown-arrow" src="assets/down_arrow_disabled.svg"/>
             
              </div>
              <div class="field-options-container">
                <app-search-dropdown [showSearch]="false" [dropdownName]="'plants'"  [displayParameter]="'plantName'" [items]="plantOptions" *ngIf="showPlantDropdown" (selectOption)="selectPlantOption($event)"></app-search-dropdown>
              </div>
            </div>
          </span>
          <span class="create-config-container" (clickOutside)="onClickedOutside()">
              <button (click)="showDropdownMenu()" [disabled]="selectedPlantName == '' || multiPlantSelected == true || !userHasAccess">
                  <div class="button-text">
                      CONFIGURE INSIGHTS
                      <img *ngIf="!showDropdown && (selectedPlantName == '' || multiPlantSelected == true || !userHasAccess )" src="assets/drop-down-gray.svg" />
                      <img *ngIf="!showDropdown && (selectedPlantName !== '' && multiPlantSelected !== true && userHasAccess )" class="downArrowDropdown" src=""/>
                      <img *ngIf="showDropdown" src="" class="upArrowDropdown"/>
                  </div>
              </button>

              <div *ngIf="showDropdown" class="options-container">
                <div *ngIf="configurationTypes?.length !== 0">
                  <div *ngFor="let configurationType of configurationTypes">
                    <button class="option" (click)="navigateToConfig(configurationType)" [disabled]="false" routerLink='{{path}}'>
                        <img class="configIcon" src=""/>
                        {{configurationType.category}}
                    </button>
                  </div>
                </div>
                <div *ngIf="configurationTypes?.length === 0">
                  <div class="no-data">
                    No Data
                  </div>
                </div>
              </div>
          </span>
        </div>
    </div>
    <div class="configuration-list-container">
        <div class ="configurations-count">
            <p class="mb-0">CONFIGURATIONS({{ dataSource.filteredData.length && userHasAccess ? dataSource.filteredData.length : '0'}})</p>
            <mat-paginator
              [hidden]="!dataSource?.filteredData?.length || !userHasAccess"
              [pageSize]="limit"
              hidePageSize="true"
              showFirstLastButtons>
            </mat-paginator>
        </div>
        <div class="line-divider">
            <div class="circle"></div>
            <div class="line"></div>
            <div class="circle"></div>
        </div>
        <div class="table-container">

          <ng-container *ngIf="!userHasAccess; else showAccess">
            <div class="access-error-container">
              <div class="access-error-message">
                <img src="assets/alert-icon.svg" alt="alert">
                <p class="header">ACCESS DENIED</p>
                <p class="message">We're sorry, but it appears that you do not have the necessary permissions to access the requested resource. Please contact the system administrator for assistance.</p>
              </div>
            </div>
          </ng-container>

          <ng-template #showAccess>
            <ng-container *ngIf="isLoading">
              <div class="loading-configuraionlist">
                  <app-three-dots-loading class="dots"></app-three-dots-loading>
                  <div class="text">Loading Configuration List...</div>
              </div>
            </ng-container>

            <ng-container *ngIf="!dataSource.filteredData.length; else showTable">
              <div class="no-config-message">
                  <img class="icon infoIcon" src=""/>
                  <div class="message">NO CONFIGURATIONS HAVE BEEN ADDED</div>
                  <div class="note">Click “Configure Insights” to add Configurations</div>
              </div>
            </ng-container>
          </ng-template>

          <ng-template #showTable>
            <!-- table -->
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">

              <!-- category Column -->
              <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef> Category Name </th>
                <td mat-cell *matCellDef="let element">
                  <span appTooltip="{{element?.category}}" [tooltipPosition]="'top'"
                  [tooltipShow]="(element?.category?.length) > 24">
                      <div class="configurationlist-text">
                        {{element.category | shorten: 24 }}
                      </div>
                  </span>
                </td>
              </ng-container>

              <!-- type Column -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef> Type </th>
                <td mat-cell *matCellDef="let element">
                  <span appTooltip="{{element?.type}}" [tooltipPosition]="'top'"
                  [tooltipShow]="(element?.type?.length) > 24">
                      <div class="configurationlist-text">
                        {{element.type | shorten: 24 }}
                      </div>
                  </span>
                </td>
              </ng-container>

               <!-- theme Column -->
               <ng-container matColumnDef="theme">
                <th mat-header-cell *matHeaderCellDef> Theme </th>
                <td mat-cell *matCellDef="let element">
                  <span appTooltip="{{element?.theme?.label}}" [tooltipPosition]="'top'"
                  [tooltipShow]="(element?.theme?.label.length) > 24">
                      <div class="configurationlist-text">
                        {{element?.theme?.label | shorten: 24 }}
                      </div>
                  </span>
                </td>
              </ng-container>

              <!-- subtype Column -->
              <ng-container matColumnDef="subtype">
                <th mat-header-cell *matHeaderCellDef> Sub-type </th>
                <td mat-cell *matCellDef="let element">
                  <span appTooltip="{{element?.subtype}}" [tooltipPosition]="'top'"
                  [tooltipShow]="(element?.subtype?.length) > 24">
                      <div class="kpi-options-text">
                        {{element.subtype | shorten: 24 }}
                      </div>
                  </span>
                </td>
              </ng-container>

              <!-- template Column -->
              <ng-container matColumnDef="template">
                <th mat-header-cell *matHeaderCellDef> Template </th>
                <td mat-cell *matCellDef="let element">
                  <span appTooltip="{{element?.template}}" [tooltipPosition]="'top'"
                  [tooltipShow]="(element?.template?.length) > 24">
                      <div class="configurationlist-text">
                        {{element.template | shorten: 24 }}
                      </div>
                  </span>
                </td>
              </ng-container>

              <!-- roleName Column -->
              <ng-container matColumnDef="roleName">
                  <th mat-header-cell *matHeaderCellDef> Role </th>
                  <td mat-cell *matCellDef="let element">
                    <span appTooltip="{{element?.role?.roleName}}" [tooltipPosition]="'top'"
                    [tooltipShow]="(element?.role?.roleName?.length) > 24">
                        <div class="configurationlist-text">
                          {{element.role?.roleName | shorten: 24 }}
                        </div>
                    </span>
                    </td>
                </ng-container>

              <!-- departmentName Column -->
              <ng-container matColumnDef="departmentName">
                  <th mat-header-cell *matHeaderCellDef> Department </th>
                  <td mat-cell *matCellDef="let element">
                    <span appTooltip="{{element?.department?.departmentName}}" [tooltipPosition]="'top'"
                    [tooltipShow]="(element?.department?.departmentName?.length) > 24">
                        <div class="configurationlist-text">
                          {{element.department.departmentName | shorten: 24 }}
                        </div>
                    </span>
                    </td>
                </ng-container>

              <!-- actionIn Column -->
              <ng-container matColumnDef="actionIn">
                  <th mat-header-cell *matHeaderCellDef> Action in </th>
                  <td mat-cell *matCellDef="let element"> {{ element?.actionIn?.value}} {{ element?.actionIn?.value > 1 ? element?.actionIn?.unit + 's' : element?.actionIn?.unit }}</td>
                </ng-container>

              <!-- createdBy Column -->
              <ng-container matColumnDef="createdBy">
                <th mat-header-cell *matHeaderCellDef> Last edited by </th>
                <td mat-cell *matCellDef="let element">
                  <span appTooltip="{{element?.createdBy}}" [tooltipPosition]="'top'"
                  [tooltipShow]="(element?.createdBy?.length) > 24">
                      <div class="configurationlist-text">
                        {{element?.createdBy | shorten: 24 }}
                      </div>
                  </span>
                  </td>
                </ng-container>

                <!-- createdDate Column -->
                <ng-container matColumnDef="createdDate">
                  <th mat-header-cell *matHeaderCellDef> Last edited on </th>
                  <td mat-cell *matCellDef="let element">
                    <span>
                        <div class="configurationlist-text">
                          {{element?.createdDate  | date: 'dd MMMM yyy  HH\':\'mm\':\'ss'}}
                        </div>
                    </span>
                  </td>
                </ng-container>

                <!-- option Column -->
                <ng-container matColumnDef="option">
                  <th style="width: 65.73px" mat-header-cell *matHeaderCellDef></th>
                  <td style="width: 65.73px" mat-cell *matCellDef="let element">
                    <button class="option-btn"[matMenuTriggerFor]="menu">
                      <img class="actionImg" src="" />
                    </button>
                    <mat-menu #menu="matMenu" class="edit-delete-options-container">
                      <div class="option">
                        <button mat-menu-item (click)="editConfiguration(element)">
                          <span class="option-text">
                            Edit
                          </span>
                        </button>
                      </div>
                      <div class="option">
                        <button mat-menu-item (click)="deleteConfiguration(element)">
                          <span class="option-text">Delete</span>
                        </button>
                      </div>
                    </mat-menu>
                  </td>
                </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          <!-- end -->
        </ng-template>
      </div>
    </div>
</div>

